'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_AGENT_RESPONDER = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var FETCH_AGENT_RESPONDER = exports.FETCH_AGENT_RESPONDER = (0, _createAsyncActionTypes.createAsyncActionTypes)('FETCH_AGENT_RESPONDER');